import { Component, OnInit, Input, OnChanges, EventEmitter, Output, SimpleChanges, ElementRef } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { LgvSettingsService, LgvUserService } from '../../core/core.module';
import { LgvModel } from '../../data-models/longevity.model';

@Component({
    selector: 'lgv-expander-v2',
    templateUrl: 'lgv-expander-v2.component.html',
    styleUrls: ['lgv-expander-v2.component.scss']
})

export class LgvExpanderV2{

    @Input() title: string;
    @Input() subtitle: string;

    @Input() panelOpenState?: boolean;

    constructor(private host: ElementRef<any>) { }

}
